var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFireLight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 1634 2562",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "fire-light_svg__a",
  d: "M0 0h1634v2562H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "fire-light_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fire-light_svg__a"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 274.382,
  cy: 2396.03,
  fill: "#FEBB12",
  fillRule: "nonzero",
  mask: "url(#fire-light_svg__b)",
  opacity: 0.1,
  rx: 63.714,
  ry: 63.718
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFireLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fire-light.bf1a50f19637093a91ecb96096e775a4.svg";